import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { formatDate } from '@angular/common';
import { Repository } from '@clavisco/core';

@Injectable()
export class IdentityInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if(request.url.includes('token'))
    {
      return next.handle(request);
    }

    type UserSession = {
      access_token: string,
      userName: string
    };

    let userToken: UserSession = Repository.Behavior.GetStorageObject<UserSession>("CurrentSession")!;

    let clonedRequest: HttpRequest<unknown> = request.clone();

    if(userToken)
    {
      let headers = clonedRequest.headers
      .set('Authorization', `Bearer ${userToken.access_token}`)
      .set('cl-ui-request-username', userToken?.userName);

      clonedRequest = clonedRequest.clone({headers});
    }

    // Agregar todos los headers que considere necesarios.
    let headers = clonedRequest.headers
    .set('cl-ui-request-timestamp', formatDate(new Date(), 'dd-MM-yyyy hh:mm:ss.SSS a', 'en'));

    clonedRequest = clonedRequest.clone({headers});

    // Valido que no tenga el header que indica si tiene archivos para no enviar el content type
    if(!clonedRequest.headers.has('Request-With-Files'))
    {
      let headers = clonedRequest.headers.set('Content-Type', 'application/json');
      clonedRequest = clonedRequest.clone({headers});
    }

    return next.handle(clonedRequest);
  }
}
